import { useRef, useState, useEffect, useCallback, useContext } from "react";
import * as StyleDOM from "./CandidateDocuments.jsx";
import Button from "../../../../Common/Button/Button.js";
import { useFormik } from "formik";
import { Toast } from "../../../../Common/Toast-Snackbar/ToastSnackbar.js";
import {
  CustomDragAndDrop,
  handleIcon,
  handleFileSelect,
  handleCustomTrim,
} from "../../../../Common/Common-Function/CommonFunctions.js";
import FileDropIcon from "../../../../Assets/Images/upload.svg";
import viewResumeIcon from "../../../../Assets/Images/resume-view.png";
import deleteIcon from "../../../../Assets/Images/delete-active-icon.png";
import { ReactComponent as DeleteIcon } from "../../../../Assets/Images/trash.svg";
import { post, get, deleteRequest } from "../../../../helper/Api_helper.js";
import {
  VYLABS_BASE_URL,
  RESUME_PARSER_BASE_URL,
  PARSED_RESUME_URL,
  PROCESS_UPLOAD_FILE,
  UPDATE_RESSUME_BY_CANID,
  GET_RESUME_PRESIGNED_URL,
  WEB_SOCKET_URL,
  GET_CANDIDATE_BY_ID,
  DOWNLOAD_CANDIDATE_RESUME,
  GET_CANDIDATE_DOCUMENTS_URL,
  CREATE_CANDIDATE_DOCUMENTS,
  GET_CANDIDATE_DOCUMENTS_LIST,
  DELETE_CANDIDATE_DOCUMENTS,
} from "../../../../helper/url_helper.js";
import ResumeViewerModal from "./ResumeViewerModal.js";
import { ConfirmationPopup } from "../../../../Common/PopupStyles/PopupComponent";
import VybogTALLoaderAnimation from "../../../../Common/Dynamic-Animations/DynamicAnimations.js";
import { DynamicContext } from "../../../../Context/DynamicContext.js";
import ViewIcon from "../../../../Assets/Images/file-view-white-icon.png";
import DownloadIcon from "../../../../Assets/Images/download-white-icon.png";
import Table from "../../../../Common/Table/Table.js";
const RESUME_FILE_EXTENSIONS = [".pdf", ".docx", ".doc", ".txt"];
const IMAGE_FILE_EXTENSIONS = [
  ".jpg",
  ".jpeg",
  ".jfif",
  ".png",
  ".gif",
  ".bmp",
  ".webp",
  ".svg",
  ".tif",
  ".tiff",
  ".ico",
  ".heic",
  ".heif",
  ".avif",
];

const OTHER_FILE_EXTENSIONS = [
  ...RESUME_FILE_EXTENSIONS,
  ...IMAGE_FILE_EXTENSIONS,
];

const RESUME_FILE_ACCEPT = RESUME_FILE_EXTENSIONS.join(",");
const OTHER_FILE_ACCEPT = OTHER_FILE_EXTENSIONS.join(",");

function CandidateDocuments({
  candidate,
  onCandidateUpdate,
  setIsDocumentsLoading,
}) {
  const ref = useRef(null);
  const { setRefetchCanList, userDetails, tenantDetails, MemberAccess } =
    useContext(DynamicContext);
  const [documentTracking, setDocumentTracking] = useState([]);
  const [uploadedResumes, setUploadedResumes] = useState([]);
  const [uploadedOtherFiles, setUploadedOtherFiles] = useState();
  const [showResumeModal, setShowResumeModal] = useState(false);
  const [resumeUrl, setResumeUrl] = useState("");
  const [resumeName, setResumeName] = useState("");
  const [isLoadingViewResume, setIsLoadingViewResume] = useState(false);
  const [lastClickedFile, setLastClickedFile] = useState(null);
  const [socket, setSocket] = useState(null);
  const [reconnectAttempts, setReconnectAttempts] = useState(0);
  const [showMismatchPopup, setShowMismatchPopup] = useState(false);
  const [mismatchFileData, setMismatchFileData] = useState(null);
  const [isForceUpdating, setIsForceUpdating] = useState(false);
  const [isProcessingResume, setIsProcessingResume] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const [downloadingFile, setDownloadingFile] = useState(null);
  const [isResumeOrOthers, setResumeOrOthers] = useState(0);
  const [otherDocuments, setOtherDocuments] = useState([]);
  const [isLoadingDocuments, setIsLoadingDocuments] = useState(false);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [documentToDelete, setDocumentToDelete] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);
  const [isUploadingOtherFile, setIsUploadingOtherFile] = useState(false);
  const socketRef = useRef(null);
  const reconnectTimeoutRef = useRef(null);
  const pingIntervalRef = useRef(null);
  const pingTimeoutRef = useRef(null);
  const isConnectingRef = useRef(false);
  const lastPingTimeRef = useRef(null);
  const MAX_RECONNECT_ATTEMPTS = 5;
  const BASE_RECONNECT_DELAY = 1000;
  const PING_INTERVAL = 30000;
  const PING_TIMEOUT = 10000;
  const { id } = candidate;
  const { files = [] } = candidate;
  const resumeFiles = Array.isArray(files) ? files : [];
  const isVySystemsTenant =
    userDetails?.tenant_id === "a65d44b742594760a1f95f3511097d19" ||
    tenantDetails?.id === "a65d44b742594760a1f95f3511097d19";

  const uploadedResumesRef = useRef(uploadedResumes);
  const candidateRef = useRef(candidate);

  useEffect(() => {
    uploadedResumesRef.current = uploadedResumes;
  }, [uploadedResumes]);

  useEffect(() => {
    candidateRef.current = candidate;
  }, [candidate]);

  const refreshCandidateData = useCallback(async () => {
    if (!id) return;
    try {
      const response = await get(
        VYLABS_BASE_URL,
        `${GET_CANDIDATE_BY_ID}?id=${id}`,
      );
      const updatedCandidate = response?.candidate;
      const updatedFiles = response?.files;
      const updatedData = {
        ...candidate,
        ...updatedCandidate,
        files: updatedFiles || null,
        parsedResumeData: updatedCandidate?.parsed_resume
          ? JSON.parse(updatedCandidate.parsed_resume)
          : {},
      };
      if (onCandidateUpdate) {
        onCandidateUpdate(updatedData);
      }
      setRefetchCanList(true);
    } catch (error) {
      console.error("Error refreshing candidate data:", error);
    }
  }, [id, candidate, onCandidateUpdate]);

  useEffect(() => {
    return () => {
      if (socketRef.current) {
        socketRef.current.close();
      }
      if (pingIntervalRef.current) {
        clearInterval(pingIntervalRef.current);
      }
      if (pingTimeoutRef.current) {
        clearTimeout(pingTimeoutRef.current);
      }
      if (reconnectTimeoutRef.current) {
        clearTimeout(reconnectTimeoutRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (setIsDocumentsLoading) {
      setIsDocumentsLoading(isProcessingResume);
    }
  }, [isProcessingResume]);

  const handleReconnect = useCallback(() => {
    if (reconnectAttempts >= MAX_RECONNECT_ATTEMPTS) {
      console.log("Max reconnection attempts reached");
      return;
    }
    const delay = Math.min(
      BASE_RECONNECT_DELAY * Math.pow(2, reconnectAttempts + 1) +
        Math.random() * 1000,
      60000,
    );

    reconnectTimeoutRef.current = setTimeout(() => {
      setReconnectAttempts((prev) => prev + 1);
      initializeWebSocket();
    }, delay);
  }, [reconnectAttempts]);

  const startPingInterval = useCallback((ws) => {
    if (pingIntervalRef.current) {
      clearInterval(pingIntervalRef.current);
    }
    if (ws.readyState === WebSocket.OPEN) {
      console.log("Sending initial ping");
      ws.send("ping");
      lastPingTimeRef.current = Date.now();
      pingTimeoutRef.current = setTimeout(() => {
        const timeSinceLastPing = Date.now() - lastPingTimeRef.current;
        if (timeSinceLastPing > PING_TIMEOUT) {
          console.log("No pong received within timeout, reconnecting...");
          ws.close(1000, "Ping timeout");
        }
      }, PING_TIMEOUT);
    }
    pingIntervalRef.current = setInterval(() => {
      if (ws.readyState === WebSocket.OPEN) {
        console.log("Sending ping");
        ws.send("ping");
        lastPingTimeRef.current = Date.now();
        if (pingTimeoutRef.current) {
          clearTimeout(pingTimeoutRef.current);
        }
        pingTimeoutRef.current = setTimeout(() => {
          const timeSinceLastPing = Date.now() - lastPingTimeRef.current;
          if (timeSinceLastPing > PING_TIMEOUT) {
            console.log("No pong received within timeout, reconnecting...");
            ws.close(1000, "Ping timeout");
          }
        }, PING_TIMEOUT);
      }
    }, PING_INTERVAL);
  }, []);

  const initializeWebSocket = useCallback(() => {
    if (isConnectingRef.current) {
      console.log("Already attempting to connect, skipping...");
      return;
    }
    isConnectingRef.current = true;
    if (socketRef.current) {
      socketRef.current.close();
    }
    if (pingIntervalRef.current) {
      clearInterval(pingIntervalRef.current);
      pingIntervalRef.current = null;
    }
    if (pingTimeoutRef.current) {
      clearTimeout(pingTimeoutRef.current);
      pingTimeoutRef.current = null;
    }
    if (reconnectTimeoutRef.current) {
      clearTimeout(reconnectTimeoutRef.current);
      reconnectTimeoutRef.current = null;
    }

    const token = localStorage.getItem("token");
    const wsProtocol =
      window.location.protocol === "https:" ? "wss://" : "wss://";
    const wsUrl = `${wsProtocol}${WEB_SOCKET_URL}/ws?token=${encodeURIComponent(
      "Bearer " + token,
    )}`;

    try {
      console.log("Creating new WebSocket connection for resume upload...");
      const ws = new WebSocket(wsUrl);
      socketRef.current = ws;
      setSocket(ws);

      ws.onopen = () => {
        console.log("WebSocket connection established for resume upload");
        setReconnectAttempts(0);
        isConnectingRef.current = false;
        startPingInterval(ws);
      };

      ws.onmessage = (event) => {
        if (event.data === "pong") {
          if (pingTimeoutRef.current) clearTimeout(pingTimeoutRef.current);
          pingTimeoutRef.current = null;
          return;
        }

        try {
          console.log(
            "WebSocket Message Received in CandidateDocuments:",
            event.data,
          );
          const [topic, payload] = event.data.split("|");
          const trimmedTopic = topic.split(":")[0].trim();

          if (trimmedTopic === "candidate-update-file-success") {
            console.log("Resume upload successful and matched candidate");
            Toast("success", "Resume uploaded and matched successfully");
            refreshCandidateData();
            setDocumentTracking([]);
            setUploadedResumes([]);
            setIsProcessingResume(false);
            ws.close(1000, "Upload success");
          } else if (trimmedTopic === "candidate-update-file-mismatch") {
            console.log("Resume mismatch detected:", payload);
            try {
              const response = JSON.parse(payload);
              if (response.message === "only resume documents can be parsed") {
                Toast(
                  "error",
                  "Only resume documents can be parsed. Please upload a valid resume file (PDF, DOC, TXT).",
                );
                setIsProcessingResume(false);
                setDocumentTracking([]);
                setUploadedResumes([]);
                ws.close(1000, "Non-resume file");
              } else if (
                response.message === "file does not match existing candidate"
              ) {
                const uploadedFileName =
                  uploadedResumesRef.current?.[0]?.name || "Uploaded File";
                setMismatchFileData({
                  fileId: response.file_id,
                  message: (
                    <span>
                      The information in "
                      <span style={{ color: "#6860ee" }}>
                        {uploadedFileName}
                      </span>
                      " differs from the existing candidate record. Do you want
                      to overwrite the existing candidate with the new resume
                      data?
                    </span>
                  ),
                });
                setShowMismatchPopup(true);
                setIsProcessingResume(false);
                Toast(
                  "error",
                  "The uploaded résumé does not match the information provided by this candidate. Could you please upload the candidate's updated resume?",
                );
                ws.close(1000, "Upload mismatch");
              } else {
                Toast("error", response.message || "Error processing file");
                setIsProcessingResume(false);
                setDocumentTracking([]);
                setUploadedResumes([]);
                ws.close(1000, "Other error");
              }
            } catch (error) {
              console.error("Error parsing mismatch payload:", error);
              Toast("error", "Error processing file response");
              setIsProcessingResume(false);
              setDocumentTracking([]);
              setUploadedResumes([]);
            }
          }
        } catch (error) {
          console.error("WebSocket message processing error:", error);
        }
      };

      ws.onclose = (event) => {
        console.log("WebSocket connection closed in CandidateDocuments", event);
        isConnectingRef.current = false;
        if (pingIntervalRef.current) {
          clearInterval(pingIntervalRef.current);
          pingIntervalRef.current = null;
        }
        if (pingTimeoutRef.current) {
          clearTimeout(pingTimeoutRef.current);
          pingTimeoutRef.current = null;
        }
        if (event.code !== 1000) {
          console.log(
            `Connection closed with code ${event.code}, attempting to reconnect...`,
          );
          handleReconnect();
        }
      };

      ws.onerror = (error) => {
        console.error("WebSocket error in CandidateDocuments:", error);
        isConnectingRef.current = false;
        handleReconnect();
      };
    } catch (error) {
      console.error("Error creating WebSocket:", error);
      isConnectingRef.current = false;
      handleReconnect();
    }
  }, [handleReconnect, startPingInterval, refreshCandidateData]);

  const handleFileUpload = () => {
    ref.current.click();
  };

  const handleDelete = (fileName) => {
    setUploadedResumes((prev) => prev.filter((file) => file.name !== fileName));
    setDocumentTracking((prev) =>
      prev.filter((file) => file.name !== fileName),
    );
  };

  const handleOtherFileDelete = () => {
    setUploadedOtherFiles(null);
  };

  const processUploadedFile = async (fileName) => {
    let requestUrl = RESUME_PARSER_BASE_URL + PROCESS_UPLOAD_FILE;
    const token = localStorage.getItem("token");
    const requestBody = JSON.stringify({ fileNames: [fileName] });

    try {
      const response = await fetch(requestUrl, {
        method: "POST",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
        body: requestBody,
      });

      if (response.ok) {
        await updateCandidateResume(fileName);
      } else {
        const errorText = await response.text();
        console.error("Error processing file:", errorText);
      }
    } catch (error) {
      console.error("Error processing file:", error);
      setIsProcessingResume(false);
    }
  };

  const handleDownloadResume = async (file) => {
    setIsDownloading(true);
    setDownloadingFile(file.name);
    try {
      const payload = {
        candidate_id: id,
      };

      const response = await post(
        VYLABS_BASE_URL,
        DOWNLOAD_CANDIDATE_RESUME,
        payload,
      );

      if (response && response.download_url) {
        const fileExtension = file.name.split(".").pop().toLowerCase();
        let contentType = "application/octet-stream";
        switch (fileExtension) {
          case "pdf":
            contentType = "application/pdf";
            break;
          case "doc":
            contentType = "application/msword";
            break;
          case "docx":
            contentType =
              "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
            break;
          case "txt":
            contentType = "text/plain";
            break;
          default:
            contentType = "application/octet-stream";
        }
        const fileResponse = await fetch(response.download_url, {
          headers: {
            "Content-Type": contentType,
          },
        });

        if (!fileResponse.ok) {
          throw new Error("Failed to fetch file");
        }
        const blob = await fileResponse.blob();
        const blobWithCorrectType = new Blob([blob], { type: contentType });
        const link = document.createElement("a");
        const objectUrl = URL.createObjectURL(blobWithCorrectType);
        link.href = objectUrl;
        link.download = file.name || "resume";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(objectUrl);
        Toast("success", "File downloaded successfully");
      }
    } catch (error) {
      console.error("Error downloading resume:", error);
      Toast("error", "Failed to download resume. Please try again.");
    } finally {
      setIsDownloading(false);
      setDownloadingFile(null);
    }
  };

  const handleFileUploadCandidate = async () => {
    if (uploadedResumes.length <= 0) {
      Toast("error", "Please upload a file");
      return;
    }
    setIsProcessingResume(true);
    const files = uploadedResumes;
    const fileNames = uploadedResumes.map((file) => file.name);
    initializeWebSocket();
    const presignedUrls = await getPresignedUploadUrls(fileNames);
    if (!presignedUrls || presignedUrls.length === 0) {
      setIsProcessingResume(false);
      return;
    }
    const uploadPromises = files
      .filter((file, index) => presignedUrls[index])
      .map((file, index) => {
        const presignedUrl = presignedUrls[index];
        return fetch(presignedUrl, {
          method: "PUT",
          body: file,
          headers: {
            "Content-Type": "application/octet-stream",
          },
          mode: "cors",
        })
          .then((response) => {
            if (response.ok) {
              return processUploadedFile(file.name);
            } else {
              throw new Error(`Upload failed for ${file.name}`);
            }
          })
          .catch((error) => {
            console.error("Upload error:", error);
            Toast("error", `File upload failed: ${error.message}`);
            setIsProcessingResume(false);
          });
      });

    await Promise.all(uploadPromises);
  };

  const handleOtherFileUploadCandidate = async () => {
    if (!uploadedOtherFiles) {
      Toast("error", "Please upload a file");
      return;
    }

    const file = uploadedOtherFiles;
    setIsUploadingOtherFile(true);

    try {
      const res = await post(VYLABS_BASE_URL, GET_CANDIDATE_DOCUMENTS_URL, {
        candidate_id: id,
        file_name: file.name,
      });
      await fetch(res.presigned_url, {
        method: "PUT",
        body: file,
        headers: {
          "Content-Type": file.type || "application/octet-stream",
        },
      });
      const fileName = res.object_key.split("/").pop();
      const documentType = fileName.split(".").pop();
      await post(VYLABS_BASE_URL, CREATE_CANDIDATE_DOCUMENTS, {
        candidate_id: id,
        document_type: documentType,
        file_name: fileName,
        object_key: res.object_key,
      });
      Toast("success", "File uploaded successfully");
      await getOtherFilesList();
      setUploadedOtherFiles(null);
    } catch (error) {
      console.error("Other file upload error:", error);
      Toast("error", "Failed to upload file");
    } finally {
      setIsUploadingOtherFile(false);
    }
  };

  const handleForceUpdate = async () => {
    if (!mismatchFileData?.fileId) {
      Toast("error", "File ID not available");
      return;
    }

    setIsForceUpdating(true);
    try {
      const response = await post(VYLABS_BASE_URL, UPDATE_RESSUME_BY_CANID, {
        candidateID: id,
        FileID: mismatchFileData.fileId,
      });
      console.log("Force update response:", response);
      Toast("success", "Candidate updated with resume data successfully");
      await refreshCandidateData();
      setShowMismatchPopup(false);
      setMismatchFileData(null);
      setDocumentTracking([]);
      setUploadedResumes([]);
    } catch (error) {
      console.error("Error force updating candidate:", error);
      Toast("error", "Failed to update candidate with resume data");
    } finally {
      setIsForceUpdating(false);
    }
  };

  const getPresignedUploadUrls = async (files) => {
    const token = localStorage.getItem("token");
    const requestBody = JSON.stringify({ FileNames: files });
    try {
      const response = await fetch(RESUME_PARSER_BASE_URL + PARSED_RESUME_URL, {
        method: "POST",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
        body: requestBody,
      });

      const data = await response.json();
      return data.PresignedUploadURLs;
    } catch (error) {
      console.error("Error getting presigned URLs:", error);
      return [];
    }
  };

  const getOtherFilesList = async () => {
    setIsLoadingDocuments(true);
    try {
      const response = await get(
        VYLABS_BASE_URL,
        `${GET_CANDIDATE_DOCUMENTS_LIST}?candidate_id=${id}`,
      );
      setOtherDocuments(
        Array.isArray(response?.documents) ? response.documents : [],
      );
    } catch (error) {
      console.error("Error GET_CANDIDATE_DOCUMENTS_LIST:", error);
      Toast("error", "Failed to load documents");
    } finally {
      setIsLoadingDocuments(false);
    }
  };

  const updateCandidateResume = async (fileName) => {
    try {
      const response = await post(VYLABS_BASE_URL, UPDATE_RESSUME_BY_CANID, {
        candidateID: id,
        FileName: fileName,
      });
      console.log("Update candidate resume response:", response);
      if (response && response.status === "success") {
        Toast("success", "File updated Successfully");
        setDocumentTracking([]);
        setUploadedResumes([]);
        await refreshCandidateData();
      }
    } catch (error) {
      console.error("Error updating candidate resume:", error);
      if (error.response?.data?.includes("mismatch")) {
        console.log("Mismatch detected, waiting for WebSocket message...");
      } else {
        Toast("error", "Failed to update resume");
        setIsProcessingResume(false);
      }
    }
  };

  const AllowedFiles = (files) => {
    const isOthersTab = isResumeOrOthers === 1;
    const allowedExtensions = isOthersTab
      ? OTHER_FILE_EXTENSIONS
      : RESUME_FILE_EXTENSIONS;

    const validFiles = handleFileSelect(files, allowedExtensions, 10);
    if (validFiles.length > 0) {
      const newFilesData = validFiles.map((file) => ({
        name: file.name,
        file: file,
      }));
      return newFilesData;
    } else {
      Toast(
        "warning",
        isOthersTab
          ? "Please upload files with valid formats: PDF, DOC, TXT or image files (JPG, PNG, GIF, WEBP, SVG, etc.)."
          : "Please upload files with valid formats: PDF, DOC, TXT.",
      );
      return [];
    }
  };

  const handleFileInputChange = (e) => {
    const files = Array.from(e.target.files);
    const newFilesData = AllowedFiles(files);
    if (isResumeOrOthers === 0) {
      if (newFilesData.length > 0) {
        const newFile = newFilesData[0];
        setDocumentTracking([newFile]);
        setUploadedResumes([newFile.file]);
      }
    } else if (isResumeOrOthers === 1) {
      if (newFilesData.length > 0) {
        const newFile = newFilesData[0];
        setUploadedOtherFiles(newFile.file);
      }
    }
  };

  const handleDropFiles = (event) => {
    event.preventDefault();
    const files = Array.from(event.dataTransfer.files);
    const newFilesData = AllowedFiles(files);
    if (isResumeOrOthers === 0) {
      if (newFilesData.length > 0) {
        const newFile = newFilesData[0];
        setDocumentTracking([newFile]);
        setUploadedResumes([newFile.file]);
      }
    } else if (isResumeOrOthers === 1) {
      if (newFilesData.length > 0) {
        const newFile = newFilesData[0];
        setUploadedOtherFiles(newFile.file);
      }
    }
  };

  const trimDescriptions = (jobsContainer) => {
    return jobsContainer.map((job) => {
      return handleCustomTrim(job);
    });
  };

  const formik = useFormik({
    initialValues: {
      jobsContainer: [],
    },
    onSubmit: (values) => {
      if (documentTracking.length === 0) {
        Toast("warning", "Please upload at least one file.");
        return;
      }
      const trimmedJobsContainer = trimDescriptions(documentTracking);
      formik.setFieldValue("jobsContainer", trimmedJobsContainer);
      setDocumentTracking([]);
      Toast("success", "Files successfully added.");
    },
  });

  const { isDragging, handleDragEnter, handleDragOver, handleDragLeave } =
    CustomDragAndDrop(handleDropFiles, false);

  const getFreshPresignedUrl = async (file) => {
    if (!id) {
      return null;
    }
    try {
      const payload = {
        candidate_id: id,
      };

      const response = await post(
        VYLABS_BASE_URL,
        GET_RESUME_PRESIGNED_URL,
        payload,
      );

      return response;
    } catch (error) {
      console.error("Error fetching fresh presigned URL:", error);
      throw error;
    }
  };

  const handleViewResume = async (file) => {
    if (!file) {
      Toast("warning", "File information not available");
      return;
    }
    const fileName = file.name;
    setIsLoadingViewResume(true);
    setLastClickedFile(fileName);
    if (file.localUrl) {
      setResumeUrl(file.localUrl);
      setResumeName(fileName);
      setShowResumeModal(true);
      setIsLoadingViewResume(false);
      setLastClickedFile(null);
      return;
    }
    try {
      const freshUrlResponse = await getFreshPresignedUrl(file);
      let finalUrl = null;
      if (freshUrlResponse && freshUrlResponse.presigned_url) {
        finalUrl = freshUrlResponse.presigned_url;
      } else if (file.presigned_url) {
        finalUrl = file.presigned_url;
        console.log("Using original presigned URL for:", fileName);
      } else {
        Toast("warning", "Resume preview not available.");
        setIsLoadingViewResume(false);
        setLastClickedFile(null);
        return;
      }
      setResumeUrl(finalUrl);
      setResumeName(fileName);
      setShowResumeModal(true);
    } catch (error) {
      console.error("Error fetching presigned URL:", error);
      if (file.presigned_url) {
        setResumeUrl(file.presigned_url);
        setResumeName(fileName);
        setShowResumeModal(true);
      }
    } finally {
      setIsLoadingViewResume(false);
      setLastClickedFile(null);
    }
  };

  const renderResumeFiles = () => {
    if (resumeFiles.length === 0) {
      return null;
    }

    return resumeFiles.map((file, index) => {
      const fileName = file.name || "Unknown File";
      const isThisFileLoading =
        isLoadingViewResume && lastClickedFile === fileName;
      const isThisFileDownloading =
        isDownloading && downloadingFile === fileName;
      return (
        <StyleDOM.DocumentMainInnerContainer
          key={index}
          className="content-innercontainer"
        >
          <StyleDOM.ContentDocumentContainer className="content-documentcontainer">
            <StyleDOM.ContentDocumentDescription className="content-description">
              <StyleDOM.PdfIcon src={handleIcon(fileName)} />
              <StyleDOM.ContentItems className="content-items">
                <StyleDOM.ContentHeading>{fileName}</StyleDOM.ContentHeading>
                <StyleDOM.StyledFileTailContents className="file-details-tail-content">
                  <Button
                    label={isThisFileLoading ? "Loading..." : "View"}
                    event={() => handleViewResume(file)}
                    disabled={isThisFileLoading}
                    iconSrc={ViewIcon}
                  />
                  {(!MemberAccess || isVySystemsTenant) && (
                    <Button
                      label={
                        isThisFileDownloading ? "Downloading..." : "Download"
                      }
                      event={() => handleDownloadResume(file)}
                      style={{ marginLeft: "10px" }}
                      disabled={isThisFileDownloading}
                      iconSrc={DownloadIcon}
                    />
                  )}
                </StyleDOM.StyledFileTailContents>
              </StyleDOM.ContentItems>
            </StyleDOM.ContentDocumentDescription>
          </StyleDOM.ContentDocumentContainer>
        </StyleDOM.DocumentMainInnerContainer>
      );
    });
  };

  const handleViewOtherDocument = async (document) => {
    if (!document.presigned_url) {
      Toast("warning", "Document preview not available");
      return;
    }
    setResumeUrl(document.presigned_url);
    setResumeName(document.file_name);
    setShowResumeModal(true);
  };

  const confirmDeleteOtherDocument = (document) => {
    setDocumentToDelete(document);
    setShowDeletePopup(true);
  };

  const handleDeleteOtherDocument = async () => {
    if (!documentToDelete) return;
    setIsDeleting(true);
    try {
      const response = await deleteRequest(
        VYLABS_BASE_URL,
        `${DELETE_CANDIDATE_DOCUMENTS}?id=${documentToDelete?.id}`,
      );
      console.log("handleDeleteOtherDocument", response);
      Toast("success", "Document deleted successfully");
      await getOtherFilesList();
    } catch (error) {
      console.log("handleDeleteOtherDocument", error);
      Toast("error", "Failed to delete document. Please try again.");
    } finally {
      setIsDeleting(false);
      setShowDeletePopup(false);
      setDocumentToDelete(null);
    }
  };
  const otherDocumentsColumns = [
    {
      name: "File Name",
      selector: (row) => row.file_name,
      sortable: true,
      cell: (row) => <div style={{ fontWeight: 500 }}>{row.file_name}</div>,
    },
    {
      name: "Document Type",
      selector: (row) => row.document_type?.toUpperCase() || "-",
      sortable: true,
      width: "150px",
    },
    {
      name: "Uploaded Date",
      selector: (row) => row.created_at,
      sortable: true,
      width: "200px",
      cell: (row) => (
        <div>{new Date(row.created_at).toLocaleDateString()} </div>
      ),
    },
    {
      name: "Actions",
      width: "150px",
      cell: (row) => (
        <div style={{ display: "flex", gap: "10px" }}>
          <img
            src={viewResumeIcon}
            alt="viewResumeIcon"
            onClick={() => handleViewOtherDocument(row)}
            style={{ width: "20px", height: "20px", cursor: "pointer" }}
          />
          <img
            src={deleteIcon}
            alt="deleteIcon"
            onClick={() => confirmDeleteOtherDocument(row)}
            style={{ width: "20px", height: "20px", cursor: "pointer" }}
          />
        </div>
      ),
    },
  ];
  return (
    <>
      {isProcessingResume || isUploadingOtherFile ? (
        <div
          style={{
            height: "100%",
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <VybogTALLoaderAnimation />
        </div>
      ) : (
        <>
          <StyleDOM.TrackingMainContainer className="trackingmain-container">
            <StyleDOM.TrackingUpperOuterContainer className="tracking-outercontainer">
              <StyleDOM.DocumentHeading
                style={{
                  marginTop: "0",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                {isResumeOrOthers === 0 ? (
                  <div>Upload Resume</div>
                ) : (
                  <div>Upload File</div>
                )}
                <div className="filter-stages" style={{ display: "flex" }}>
                  <Button
                    label="Resume"
                    event={() => {
                      setResumeOrOthers(0);
                    }}
                    className={`grid-btn ${
                      isResumeOrOthers === 0 ? "active" : ""
                    }`}
                  />
                  <Button
                    label="Others"
                    event={() => {
                      setResumeOrOthers(1);
                      getOtherFilesList();
                    }}
                    className={`grid-btn ${
                      isResumeOrOthers === 1 ? "active" : ""
                    }`}
                  />
                </div>
              </StyleDOM.DocumentHeading>
              {isResumeOrOthers === 0 ? (
                <StyleDOM.TrackingUpperContainer className="trackingupper-container">
                  <StyleDOM.DocumentLeftContainer className="documentleft-container">
                    {documentTracking.length === 0 ? (
                      <StyleDOM.FileDropMainContainer
                        className="filedropmain-container"
                        style={{ width: "100%" }}
                      >
                        <StyleDOM.FileDropContainer
                          onClick={handleFileUpload}
                          onDragEnter={handleDragEnter}
                          onDragOver={handleDragOver}
                          onDragLeave={handleDragLeave}
                          onDrop={handleDropFiles}
                          isDragging={isDragging}
                          className="FileDrop-container"
                        >
                          <img src={FileDropIcon} alt="File-uploadicon" />
                          <StyleDOM.FileDropMessage>
                            {isDragging
                              ? "Drop your resumes here"
                              : "Drag and Drop your resumes"}
                          </StyleDOM.FileDropMessage>
                          <StyleDOM.NoteListContainer className="NoteList-container">
                            <StyleDOM.NoteList>
                              The resume size should not exceed 10 mb
                            </StyleDOM.NoteList>
                            <StyleDOM.NoteList>
                              You can upload only one resume at a time
                            </StyleDOM.NoteList>
                            <StyleDOM.NoteList>
                              Supported Formats: PDF, DOC, TXT
                            </StyleDOM.NoteList>
                          </StyleDOM.NoteListContainer>
                          <input
                            accept={RESUME_FILE_ACCEPT}
                            name="fileName"
                            type="file"
                            ref={ref}
                            style={{ display: "none" }}
                            onChange={handleFileInputChange}
                          />
                        </StyleDOM.FileDropContainer>
                      </StyleDOM.FileDropMainContainer>
                    ) : (
                      <>
                        <StyleDOM.FileDropMainContainer
                          className="filedropmain-container"
                          style={{ width: "80%" }}
                        >
                          <StyleDOM.FileDropContainer
                            onClick={handleFileUpload}
                            onDragEnter={handleDragEnter}
                            onDragOver={handleDragOver}
                            onDragLeave={handleDragLeave}
                            onDrop={handleDropFiles}
                            isDragging={isDragging}
                            className="FileDrop-container"
                          >
                            <img src={FileDropIcon} alt="File-uploadicon" />
                            <StyleDOM.FileDropMessage>
                              {isDragging
                                ? "Drop your resumes here"
                                : "Drag and Drop your resumes"}
                            </StyleDOM.FileDropMessage>
                            <StyleDOM.NoteListContainer className="NoteList-container">
                              <StyleDOM.NoteList>
                                The resume size should not exceed 10 mb
                              </StyleDOM.NoteList>
                              <StyleDOM.NoteList>
                                You can upload only one resume at a time
                              </StyleDOM.NoteList>
                              <StyleDOM.NoteList>
                                Supported Formats: PDF, DOC, TXT
                              </StyleDOM.NoteList>
                            </StyleDOM.NoteListContainer>
                            <input
                              accept={RESUME_FILE_ACCEPT}
                              name="fileName"
                              type="file"
                              ref={ref}
                              style={{ display: "none" }}
                              onChange={handleFileInputChange}
                            />
                          </StyleDOM.FileDropContainer>
                        </StyleDOM.FileDropMainContainer>
                        <StyleDOM.UploadedFilesContainer
                          style={{ width: "20%" }}
                        >
                          {documentTracking.map((file, index) => (
                            <StyleDOM.UploadedFileItem key={index}>
                              <StyleDOM.FileNameContainer>
                                {file.name}
                              </StyleDOM.FileNameContainer>
                              <StyleDOM.DeleteIconDiv
                                onClick={() => handleDelete(file.name)}
                              >
                                <DeleteIcon />
                              </StyleDOM.DeleteIconDiv>
                            </StyleDOM.UploadedFileItem>
                          ))}
                        </StyleDOM.UploadedFilesContainer>
                      </>
                    )}
                  </StyleDOM.DocumentLeftContainer>
                  <StyleDOM.DocumentRightContainer className="right-container">
                    <div>
                      <StyleDOM.DocumentDescription className="document-description">
                        <StyleDOM.StyledDocumentaButtonDiv>
                          <Button
                            label="Clear"
                            isCancel={true}
                            event={() => setDocumentTracking([])}
                          />
                          <Button
                            label="Upload Resume"
                            event={handleFileUploadCandidate}
                            disabled={uploadedResumes.length === 0}
                          />
                        </StyleDOM.StyledDocumentaButtonDiv>
                      </StyleDOM.DocumentDescription>
                    </div>
                  </StyleDOM.DocumentRightContainer>
                </StyleDOM.TrackingUpperContainer>
              ) : (
                <StyleDOM.TrackingUpperContainer className="trackingupper-container">
                  <StyleDOM.DocumentLeftContainer className="documentleft-container">
                    {!uploadedOtherFiles ? (
                      <StyleDOM.FileDropMainContainer
                        className="filedropmain-container"
                        style={{ width: "100%" }}
                      >
                        <StyleDOM.FileDropContainer
                          onClick={handleFileUpload}
                          onDragEnter={handleDragEnter}
                          onDragOver={handleDragOver}
                          onDragLeave={handleDragLeave}
                          onDrop={handleDropFiles}
                          isDragging={isDragging}
                          className="FileDrop-container"
                        >
                          <img src={FileDropIcon} alt="File-uploadicon" />
                          <StyleDOM.FileDropMessage>
                            {isDragging
                              ? "Drop your files here"
                              : "Drag and Drop your files"}
                          </StyleDOM.FileDropMessage>
                          <StyleDOM.NoteListContainer className="NoteList-container">
                            <StyleDOM.NoteList>
                              The file size should not exceed 10 mb
                            </StyleDOM.NoteList>
                            <StyleDOM.NoteList>
                              You can upload only one file at a time
                            </StyleDOM.NoteList>
                            <StyleDOM.NoteList>
                              Supported Formats: PDF, DOC, TXT and all image
                              formats
                            </StyleDOM.NoteList>
                          </StyleDOM.NoteListContainer>
                          <input
                            accept={OTHER_FILE_ACCEPT}
                            name="fileName"
                            type="file"
                            ref={ref}
                            style={{ display: "none" }}
                            onChange={handleFileInputChange}
                          />
                        </StyleDOM.FileDropContainer>
                      </StyleDOM.FileDropMainContainer>
                    ) : (
                      <>
                        <StyleDOM.FileDropMainContainer
                          className="filedropmain-container"
                          style={{ width: "80%" }}
                        >
                          <StyleDOM.FileDropContainer
                            onClick={handleFileUpload}
                            onDragEnter={handleDragEnter}
                            onDragOver={handleDragOver}
                            onDragLeave={handleDragLeave}
                            onDrop={handleDropFiles}
                            isDragging={isDragging}
                            className="FileDrop-container"
                          >
                            <img src={FileDropIcon} alt="File-uploadicon" />
                            <StyleDOM.FileDropMessage>
                              {isDragging
                                ? "Drop your files here"
                                : "Drag and Drop your files"}
                            </StyleDOM.FileDropMessage>
                            <StyleDOM.NoteListContainer className="NoteList-container">
                              <StyleDOM.NoteList>
                                The file size should not exceed 10 mb
                              </StyleDOM.NoteList>
                              <StyleDOM.NoteList>
                                You can upload only one file at a time
                              </StyleDOM.NoteList>
                              <StyleDOM.NoteList>
                                Supported Formats: PDF, DOC, TXT and all image
                                formats
                              </StyleDOM.NoteList>
                            </StyleDOM.NoteListContainer>
                            <input
                              accept={OTHER_FILE_ACCEPT}
                              name="fileName"
                              type="file"
                              ref={ref}
                              style={{ display: "none" }}
                              onChange={handleFileInputChange}
                            />
                          </StyleDOM.FileDropContainer>
                        </StyleDOM.FileDropMainContainer>
                        <StyleDOM.UploadedFilesContainer
                          style={{ width: "20%" }}
                        >
                          {uploadedOtherFiles && (
                            <StyleDOM.UploadedFileItem>
                              <StyleDOM.FileNameContainer>
                                {uploadedOtherFiles.name}
                              </StyleDOM.FileNameContainer>
                              <StyleDOM.DeleteIconDiv
                                onClick={handleOtherFileDelete}
                              >
                                <DeleteIcon />
                              </StyleDOM.DeleteIconDiv>
                            </StyleDOM.UploadedFileItem>
                          )}
                        </StyleDOM.UploadedFilesContainer>
                      </>
                    )}
                  </StyleDOM.DocumentLeftContainer>
                  <StyleDOM.DocumentRightContainer className="right-container">
                    <div>
                      <StyleDOM.DocumentDescription className="document-description">
                        <StyleDOM.StyledDocumentaButtonDiv>
                          <Button
                            label="Clear"
                            isCancel={true}
                            event={() => setUploadedOtherFiles(null)}
                          />
                          <Button
                            label="Upload File"
                            event={handleOtherFileUploadCandidate}
                            disabled={!uploadedOtherFiles}
                          />
                        </StyleDOM.StyledDocumentaButtonDiv>
                      </StyleDOM.DocumentDescription>
                    </div>
                  </StyleDOM.DocumentRightContainer>
                </StyleDOM.TrackingUpperContainer>
              )}
            </StyleDOM.TrackingUpperOuterContainer>
          </StyleDOM.TrackingMainContainer>
          <StyleDOM.ContentMainContainer className="contentMain-Container">
            {isResumeOrOthers === 0 && resumeFiles.length > 0 && (
              <h3>Uploaded Resumes</h3>
            )}
            {isResumeOrOthers === 0 && (
              <StyleDOM.DocumentLowerContainer className="document-lowercontainer">
                {renderResumeFiles()}
              </StyleDOM.DocumentLowerContainer>
            )}
          </StyleDOM.ContentMainContainer>

          {otherDocuments.length > 0 && isResumeOrOthers === 1 && (
            <div style={{ marginTop: "30px" }}>
              <h3>Uploaded Documents</h3>
              <Table
                columns={otherDocumentsColumns}
                data={otherDocuments}
                // progressPending={isLoadingDocuments}
                pagination={true}
                paginationPerPage={5}
                paginationRowsPerPageOptions={[5, 10, 15]}
                highlightOnHover={true}
              />
            </div>
          )}
        </>
      )}

      {showResumeModal && (
        <ResumeViewerModal
          url={resumeUrl}
          name={resumeName}
          onClose={() => setShowResumeModal(false)}
          isOpen={showResumeModal}
        />
      )}
      <ConfirmationPopup
        isOpen={showMismatchPopup}
        onClose={() => {
          setShowMismatchPopup(false);
          setMismatchFileData(null);
          setDocumentTracking([]);
          setUploadedResumes([]);
        }}
        onConfirm={handleForceUpdate}
        title="Overwrite Candidate?"
        message={mismatchFileData?.message}
        confirmLabel={isForceUpdating ? "Overwriting..." : "Yes,Overwrite"}
        cancelLabel="No, Cancel"
        isConfirmLoading={isForceUpdating}
      />
      <ConfirmationPopup
        isOpen={showDeletePopup}
        onClose={() => {
          setShowDeletePopup(false);
          setDocumentToDelete(null);
        }}
        onConfirm={handleDeleteOtherDocument}
        title="Delete Document?"
        message={`Are you sure you want to delete "${documentToDelete?.file_name || "this document"}"? This action cannot be undone.`}
        confirmLabel={isDeleting ? "Deleting..." : "Yes, Delete"}
        cancelLabel="No, Cancel"
        isConfirmLoading={isDeleting}
      />
    </>
  );
}

export default CandidateDocuments;